import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 查询品牌类目
export const setBrands: Mutation<IModuleState> = (state, payload) => {
  const optionAll = { id: -1, nameChn: '全部', nameEng: 'all' };
  state.brands.data = [optionAll, ...payload.data];
  state.brands.raw = payload.data;
  state.brands.loading = !!payload.loading;
};

// 后台模型类型
export const setBackTypes: Mutation<IModuleState> = (state, payload) => {
  const optionAll = { optionKey: '', optionValue: '全部' };
  state.backTypes.data = [ optionAll, ...payload.data ];
  state.backTypes.raw = payload.data;
  state.backTypes.loading = !!payload.loading;
};

// 过滤项类型
export const setFilterTypes: Mutation<IModuleState> = (state, payload) => {
  state.filterTypes.data = payload.data;
  state.filterTypes.raw = payload.data;
  state.filterTypes.loading = !!payload.loading;
};

// 实体类型
export const setEntityTypes: Mutation<IModuleState> = (state, payload) => {
  state.entityTypes.data = payload.data;
  state.entityTypes.raw = payload.data;
  state.entityTypes.loading = !!payload.loading;
};
